export default __webpack_public_path__ + "static/inschat-records-real-f4ffb5d931fa9b248843f075064eec18.png";